module.exports = __webpack_public_path__ + "static/media/medium-white.a0cb52b0.svg";